"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _formContext = require("./formContext");
Object.keys(_formContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formContext[key];
    }
  });
});
